import image1 from "../../../../src/contents/2021-11-01-image1.png";
import * as React from 'react';
export default {
  image1,
  React
};